import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class listKissUsersCtrl {
    /* @ngInject */
    constructor($state, $sessionStorage, logger, $translate, KISS_USER, KissUserSvc, UsersFilter, $scope) {
        this.$state = $state;
        this.$sessionStorage = $sessionStorage;
        this.logger = logger;
        this.$translate = $translate;
        this.KISS_USER = KISS_USER;
        this.KissUserSvc = KissUserSvc;
        this.UsersFilter = UsersFilter;
        this.$scope = $scope;
    }

    $onInit() {
        var defaultCellTemplate =
            '<a class="grid-cell-link"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.$ctrl.view(row)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';

        // ---------------
        // Data API
        // ---------------
        // Recherche
        this.profilList = this.KISS_USER.profil;
        this.statusList = this.KISS_USER.status;
        this.searchData =
            this.keepSearchData && this.$sessionStorage.listKissUsersCriteria
                ? this.$sessionStorage.listKissUsersCriteria
                : new this.UsersFilter();

        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'getOwnerEntityName()',
                    displayName: 'kiss_user.list.entity',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.login',
                    displayName: 'kiss_user.list.login',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.lastname',
                    displayName: 'kiss_user.list.lastname',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.firstname',
                    displayName: 'kiss_user.list.firstname',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.email',
                    displayName: 'kiss_user.list.email',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'user.getStatusLabel()',
                    displayName: 'kiss_user.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    width: 80,
                },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                // Sorting & pagination
                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => this.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        this.searchData.setSort(sortColumns);
                    } else {
                        this.searchData.resetSort();
                    }
                    this.search();
                });
                gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                    this.searchData.setPageSize(size);
                    this.searchData.setPage(page - 1);
                    this.search();
                });
            },
        };

        this.preparedSearchFilter = {};
        this.headers = [];

        this.clearFilter = true;

        //initialiser le filtre de recherche pour l'export
        this.preparedSearchFilter = this.searchData.preparBeforeSearch();

        //recuperer la liste des headers pour l'export
        this.headers = _.map(this.gridOptions.columnDefs, column => {
            return this.$translate.instant(column.displayName);
        });
    }

    convertSort(col) {
        var columnField = _.find(this.KISS_USER.columnFieldMap, { field: col.field });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }

    search() {
        const workflowRoleProfiles = {
            REQUESTER: 'demandeur',
            THREE_WAY_MATCHING_ACCOUNTANT: 'Comptable',
            APPROVER: 'approbateur'
        };
        const originalRole = this.searchData.role;
        this.workflowRole = workflowRoleProfiles[originalRole];
        /* Lorsque le profil recherché est un sous-ensemble d'Utilisateur Workflow (exemple : Rapprochement 3 voies comptable Rôle),
           on recherche dans un premier les utilisateurs workflow puis on filtre sur le profil recherché */
        this.searchData.role = this.workflowRole ? 'USER_WKF' : originalRole;
        this.$sessionStorage.listKissUsersCriteria = this.searchData;
        let searchResult = this.KissUserSvc.searchUsers(this.searchData);
        // On repasse le rôle d'Utilisateur Workflow vers le profil recherché pour qu'il apparaisse correctement dans la sélection
        this.searchData.role = originalRole;
        this.kissUserPromise = searchResult;
        searchResult.then(
            pageUsers => {
                if (this.workflowRole) {
                    const filteredUsers = this.filterUsers(pageUsers.users, this.workflowRole);
                    this.gridOptions.data = filteredUsers;
                    this.gridOptions.totalItems = filteredUsers.length;
                } else {
                    this.gridOptions.data = pageUsers.users;
                    this.gridOptions.totalItems = pageUsers.totalItems;
                }
                //enregistrer le filtre de recherche formaté pour l'export
                this.preparedSearchFilter = this.searchData.preparBeforeSearch();
            },
            (/*error*/) => {
                this.logger.error('error.search');
            }
        );
    }

    filterUsers(users, workflowRole) {
        return users.filter(user => {
            return user.user.legalEntityGroupUsers.some(group => group.wkfProfile === workflowRole);
        });
    }

    clearForm() {
        // Reset data
        this.searchData = new this.UsersFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }

    // Modification d'un utilisateur
    view(row) {
        this.clearFilter = false;
        var sellerId =
        row.entity.principal && (row.entity.principal.profilBuyer || row.entity.principal.profilSeller)
                ? null
                : row.entity.seller && row.entity.seller.id;
        this.$sessionStorage.isdetailUserFromKissList = true;
        this.$state.go('app.kissuser.edit', {
            principalId: row.entity.principal && row.entity.principal.id,
            id: row.entity.user.login,
            sellerId: sellerId,
            legalEntityId: null
        });
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }
}

angular.module('app.kissuser').component('listKissUsers', {
    templateUrl: require('./list-kiss-users.html'),
    controller: listKissUsersCtrl,
    bindings: {
        keepSearchData: '<',
    },
});
